<template>
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">绑定司机姓名:</span>
                        <!-- 搜索商家名称 -->
                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入司机姓名"
                            class="handle-input mr10"
                            @keyup.enter.native="searchWorkPlateList"
                        ></el-input>
                    </el-col>
                    <el-col :span="12">
                        <span class="title title1">绑定司机手机号:</span>
                        <!-- 搜索商家手机号 -->
                        <el-input
                            v-model="search_data.phone"
                            placeholder="请输入绑定司机手机号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchWorkPlateList"
                        ></el-input>
                    </el-col>
                    
                </el-row>

                <el-row class="head-search">
                    <el-col :span="24">
                        <span class="title">绑定状态:</span>

                        <el-select
                            v-model="search_data.status"
                            placeholder="请选择绑定状态"
                            clearable
                            @keyup.enter.native="searchWorkPlateList"
                        >
                            <el-option label="已绑定" value="1"> </el-option>
                            <el-option label="未绑定" value="0"> </el-option>
                        </el-select>
                    </el-col>
                   
                </el-row>
             
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchWorkPlateList">搜索</el-button>
            <el-button @click="add_isShow = !add_isShow">添加</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
          
           
        </div>
        <el-table
            :data="tableData"
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
           
        >
          
            <el-table-column label="id" prop="id"> </el-table-column>
            <!-- 可以线下支付，但是线下支付不给奖励，只有线上支付给奖励 -->
            <el-table-column prop="work_plate_code" label="司机推广码">
                <template slot-scope="scope">
                    <el-image
                        style="width: 80px; height: 80px; border: 1px solid #eee; border-radius: 5px"
                        :src="scope.row.reward_qrcode"
                        v-if="scope.row.reward_qrcode != ''"
                        :preview-src-list="srcList"
                    >
                    </el-image>
                </template>
            </el-table-column>
            <el-table-column label="二维码code" prop="work_plate_code"> </el-table-column>
            
            
            <el-table-column label="创建时间" prop="createTime_stamp"> </el-table-column>
            <el-table-column label="绑定司机姓名" prop="name"> </el-table-column>
            <el-table-column label="绑定司机手机号" prop="phone"> </el-table-column>
            <el-table-column label="绑定状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status == '未绑定' ? 'danger' : 'success'">{{scope.row.status}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作人" prop="update_admin_name" min-width="100"> </el-table-column>
            <el-table-column label="最后操作时间" prop="time_stamp"> </el-table-column>

          

            <el-table-column label="操作" width="270" align="center">
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.status=='未绑定'"
                        
                        type="primary"
                        trigger="click"
                        @click="
                            bingWorkPlate_show = !bingWorkPlate_show;
                            work_plate_code = scope.row.work_plate_code;
                           
                        "
                    >
                        绑定司机
                       
                    </el-button>
                    <el-button
                    
                        v-if="scope.row.status=='已绑定'"
                        type="info"
                        trigger="click"
                        @click="unBingWorkPlate(scope.row.work_plate_code,scope.row.driver_code)"
                    >
                        解绑司机
                       
                    </el-button>

                    
                   
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 添加组件 -->
        <addWorkPlate :isShow="add_isShow" @onSubmit="workPlateList"></addWorkPlate>

     

        <!-- 绑定司机组件 -->
        <bingWorkPlate :isShow="bingWorkPlate_show" :data="work_plate_code" @onSubmit="workPlateList" ></bingWorkPlate>
    </div>
</template>

<script>
var _this;
import addWorkPlate from './addWorkPlate.vue';

import bingWorkPlate from './bingWorkPlate.vue';

export default {
    components: {
        addWorkPlate,
        
        bingWorkPlate
    },
    data() {
        return {
            bingWorkPlate_show: false,

            srcList: [],

         

            work_plate_code: '',

            add_isShow: false,

            bingWorkPlate_show: false,

            // 存放表格数据
            tableData: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                phone: '',
                status: '',
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.workPlateList();
    },

    methods: {
       
      
        unBingWorkPlate(work_plate_code,driver_code){
            _this.work_plate_code = work_plate_code;
            _this.driver_code = driver_code;
         
             _this
                .$post('/driver/unBingWorkPlate', {
                    work_plate_code:_this.work_plate_code,
                    driver_code:_this.driver_code
                })
                .then((res) => {
                    this.$message.success(res.msg);
                    _this.workPlateList();
                })

        },
       

        searchWorkPlateList() {
            _this.search_data.page = 1;
            _this.workPlateList();
        },

        workPlateList() {
            _this
                .$post('/driver/workPlateList', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                    _this.srcList.length = 0;
                    for (let i = 0; i < res.data.length; i++) {
                        _this.srcList.push(res.data[i].head_img);
                        _this.srcList.push(res.data[i].reward_qrcode);
                    }
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.workPlateList();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.head-search .title1 {
    display: inline-block !important;
    width: 180px !important;
    text-align: right !important;
    padding-right: 5px !important;
    -webkit-box-sizing: border-box !important;
    box-sizing: border-box !important;
    background-color: transparent !important;
    color: #000;

}
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
